// extracted by mini-css-extract-plugin
module.exports = {"selector-container":"inventoriesPicker_selector-container__ryD78"};